module.exports = __webpack_public_path__ + "static/media/flowers_7.88fb5704.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_7.csv
// module id = 764
// module chunks = 0